import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './layout/main/main.component';
import { UnderMainatanceComponent } from './pages/under-mainatance/under-mainatance.component';
import { LoginComponent } from './pages/login/login.component';
import { AuthGuard } from './guard/auth-guard/auth.guard';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ResetPassPageComponent } from './pages/reset-pass/reset-pass-page.component';
import { NoAccessPageComponent } from './pages/no-access-page/no-access-page.component';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    data: {
      title: 'Forgot Password',
    },
  },
  {
    path: 'reset-password/:Id/:time',
    component: ResetPassPageComponent,
    data: {
      title: 'Set Password',
    },
  },
  {
    path: '',
    component: MainComponent,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./layout/main/main.module').then((m) => m.MainModule),
  },
  {
    path: 'under-maintenance',
    component: UnderMainatanceComponent,
  },
  {
    path: 'no-access',
    component: NoAccessPageComponent,
  },
  {
    path: '**',
    loadChildren: () =>
      import('./pages/page-not-found/page-not-found.module').then(
        (m) => m.PageNotFoundModule
      ),
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
